import { cn } from "@/lib/utils";

export const PixelStar = ({ className = "", size = 28, color = "#FFD84D" }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" className={className} aria-hidden>
    <g fill={color} stroke="#111111" strokeWidth="0.5">
      <rect x="7" y="1" width="2" height="2" />
      <rect x="7" y="13" width="2" height="2" />
      <rect x="1" y="7" width="2" height="2" />
      <rect x="13" y="7" width="2" height="2" />
      <rect x="6" y="3" width="4" height="10" />
      <rect x="3" y="6" width="10" height="4" />
    </g>
  </svg>
);

export const PixelSmiley = ({ className = "", size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" className={className} aria-hidden>
    <circle cx="10" cy="10" r="9" fill="#FFD84D" stroke="#111111" strokeWidth="1.5" />
    <rect x="6" y="7" width="2" height="2" fill="#111" />
    <rect x="12" y="7" width="2" height="2" fill="#111" />
    <path d="M6 12 Q10 15 14 12" stroke="#111" strokeWidth="1.5" fill="none" strokeLinecap="round" />
  </svg>
);

export const PixelHeart = ({ className = "", size = 28, color = "#FF8FB3" }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" className={className} aria-hidden>
    <g fill={color} stroke="#111111" strokeWidth="0.5">
      <rect x="2" y="3" width="4" height="4" />
      <rect x="10" y="3" width="4" height="4" />
      <rect x="1" y="5" width="14" height="3" />
      <rect x="3" y="8" width="10" height="2" />
      <rect x="5" y="10" width="6" height="2" />
      <rect x="7" y="12" width="2" height="2" />
    </g>
  </svg>
);

export const PixelSparkle = ({ className = "", size = 24, color = "#7C5CFF" }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" className={className} aria-hidden>
    <g fill={color} stroke="#111111" strokeWidth="0.5">
      <rect x="7" y="2" width="2" height="4" />
      <rect x="7" y="10" width="2" height="4" />
      <rect x="2" y="7" width="4" height="2" />
      <rect x="10" y="7" width="4" height="2" />
    </g>
  </svg>
);

export const Tape = ({ className = "", color = "#FFD84D", rotate = -6 }) => (
  <div
    className={cn("absolute h-6 w-24", className)}
    style={{
      background: color,
      border: "1.5px solid rgba(17,17,17,0.25)",
      transform: `rotate(${rotate}deg)`,
      boxShadow: "1px 2px 0 rgba(0,0,0,0.08)",
    }}
  />
);

export default PixelStar;
